import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Check } from "lucide-react";
import { Reveal } from "../../lib/motion";
import { COMPANY, IMAGES } from "../../data/site";

const POINTS = [
  "Certified, fiduciary-first advice",
  "Zero pushy product-selling",
  "Goal-mapped, not market-timed",
  "Transparent, jargon-free reviews",
];

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "10%"]);

  return (
    <section id="about" data-testid="about-section" ref={ref} className="py-24 lg:py-32 relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Portrait */}
        <div className="lg:col-span-5 relative">
          <div className="relative h-[440px] lg:h-[560px] rounded-b-[120px] rounded-tr-[120px] overflow-hidden border border-white/10">
            <motion.img
              style={{ y }}
              src={IMAGES.planner}
              alt={COMPANY.planner}
              className="absolute inset-0 w-full h-[120%] object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0F1C]/70 via-transparent to-transparent" />
          </div>
          <div className="absolute -bottom-6 -right-2 lg:right-6 bg-[#111827] border border-[var(--accent)]/40 rounded-2xl px-6 py-4 gold-glow">
            <div className="font-display text-2xl text-[var(--text)]">{COMPANY.planner}</div>
            <div className="text-xs uppercase tracking-widest text-gold mt-1">{COMPANY.role}</div>
          </div>
        </div>

        {/* Copy */}
        <div className="lg:col-span-7 lg:pl-6">
          <Reveal><p className="overline mb-4">The advisor</p></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[var(--text)] leading-[1.03]">
              Guidance you can <span className="text-gold italic">trust</span> with your family&rsquo;s future.
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-8 text-white/70 text-base lg:text-lg leading-relaxed max-w-xl">
              At {COMPANY.name}, {COMPANY.planner} brings over a decade of disciplined planning to
              families across India. The philosophy is simple — understand the person first, then
              build a portfolio of Mutual Funds, SIPs and Specialized Funds that quietly does its job
              while you live your life.
            </p>
          </Reveal>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {POINTS.map((p, i) => (
              <Reveal key={p} delay={0.1 + i * 0.06}>
                <div className="flex items-center gap-3">
                  <span className="w-7 h-7 rounded-full bg-[var(--accent)]/15 flex items-center justify-center text-gold shrink-0">
                    <Check size={15} />
                  </span>
                  <span className="text-white/80 text-sm">{p}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
